/*
  Page Module: Book Interpreter
*/
window.SMTX.BookInterpreter = (function () {

  if( $('.book-interpreter').length < 1 ){
    return false;
  }

  var API_BASE = '/api/easyorder';
  var loader = {
        message: '<img src="/static/icons/spinner.svg" class="blockUI__spinner fixed-center" width="64" height="64" />',
        centerY: false,
        centerX: false,
        css:{
            position: 'fixed',
            margin: 'auto'
        },
        overlayCSS: {
          background: '#fff',
          opacity: 0.6
        }
      };

  var init = function () {
    if(!$('.book-interpreter').length) {
      return;
    }

    // Reset blockUI default css
    $.blockUI.defaults.css = {};

    // If everything validates, post the form
    $('input#contact-id').on('keyup', onContactIdChange);
    $('button.check-contact-id').on('click', postContactIdIfValidated);

    $('input#contact-id').on('input blur paste', updateContactIdButtonIfValidated);

    // Run a check if input is filled on page load
    onContactIdChange({});
  };

  var onContactIdChange = function(e) {
    if (e.keyCode == 13) {
      postContactIdIfValidated();
    }

    updateContactIdButtonIfValidated();
  };

  var validateContactIdField = function() {
    if($('input#contact-id').val().length > 0) {
      return true;
    }
    return false;
  };

  var updateContactIdButtonIfValidated = function() {
    // Take away inactive state on button if it validates
    if(validateContactIdField()) {
      $('button.check-contact-id').removeClass('button--inactive');
    } else {
      //$('button.check-contact-id').addClass('button--inactive');
    }
  };

  var postContactIdIfValidated = function(e) {
    e.preventDefault();

    if(validateContactIdField()) {
      // Disable error messages while trying to validate
      $('input#contact-id').removeClass('is-invalid-input');
      $('.book-interpreter__error-message').removeClass('is-visible');

      $('input#contact-id').removeClass('is-invalid-input');
      blockUI(loader);
      apiCalls.contactValidation($('input#contact-id').val());
    } else {
      // Doesnt validate, make red and fade
      $('input#contact-id').addClass('is-invalid-input');
    }
  };

  var postFormToEasyOrder = function() {

    // $(this).parents('form').submit();
  };

  // Gets all available languages
  var apiCalls = {
    contactValidation: function(contactId) {
      var validateData = {
        'contactId': contactId
      };

      $.ajax({
        method: "POST",
        timeout: 0,
        url: API_BASE + '/v3/contact/validate',
        contentType: "application/json",
        // dataType: 'json',
        //processData: false,
        data: JSON.stringify(validateData),
        success: apiCallbacks.contactValidationSuccess,
        error: apiCallbacks.contactValidationFail
      });
    }
  };

  var apiCallbacks = {

    contactValidationSuccess: function (data, textStatus, xhr) {

      unblockUI();

      data = JSON.parse(data);


      if( data.organisationCountryCode && data.organisationCountryCode === window.SMTX.eo.valid_user_country_code){
        $('#api-contact-id').val(data.contactId);
        $('#api-org-id').val(data.organisationId);
        $('#api-org-country-code').val(data.organisationCountryCode);
        // Show Order-page
        $('.book-interpreter__container').addClass('book-interpreter__container--validated');
        $('input#contact-id').removeClass('is-invalid-input');
        $('.book-interpreter__error-message').removeClass('is-visible');
      }else{
        $('input#contact-id').addClass('is-invalid-input');
        $('.book-interpreter__error-message[data-country-code]').addClass('is-visible');
      }

    },

    contactValidationFail:  function (xhr, textStatus, err) {
      unblockUI();

      // Show message about contact ID not being correct
      $('input#contact-id').addClass('is-invalid-input');

      $('.book-interpreter__error-message[data-contact-id]').addClass('is-visible');
    }
  };

  var scrollToPos = function ($pos) {
    var scrollEvents = "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove";

    // Reset animated scroll if it's already animating
    $("html, body").stop();
    $("html, body").off(scrollEvents);

    // Scroll to position $pos
    $("html, body").on(scrollEvents, function(){
      $("html, body").stop(); // Stop scrolling if we scroll while scrollTop is animating
    });

    $("html, body").animate({ scrollTop: $pos }, 300, function(){
      $("html, body").off(scrollEvents);
    });
  };

  var blockUI = function (settings) {
    // $('.EasyOrder').block(settings);

    $.blockUI(settings);
  };

  var unblockUI = function () {
    // $('.EasyOrder').unblock();
    $.unblockUI();
  };

  init();
})();
